/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import Axios from "axios";

export default {
  get() {
    return Axios.post(
      "https://register.bz-uk.roamingowl.com/widgets/dp-gallery/bc3ebc3c-253e-43a9-9243-a763708d013g?api_key=mdDIUVkJ0AyFNA23UF0J0ztA8r72kbXe",
      { apiKey: "mdDIUVkJ0AyFNA23UF0J0ztA8r72kbXe" }
    ).then(response => {
      return response.data;
    });
  }
};
